var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loadmore",rawName:"v-loadmore",value:(_vm.loadmore),expression:"loadmore"}],staticClass:"tree-menu"},_vm._l((_vm.treeData),function(menuItem){return _c('ul',{key:menuItem.id},[_c('en-tree-item',{attrs:{"model":menuItem},on:{"selectCaputure":_vm.onselected}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }